import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

const categoryIcons: Record<string, string> = {
  all: 'ri-apps-line',
  action: 'ri-sword-line',
  drama: 'ri-emotion-line',
  comedy: 'ri-emotion-happy-line',
  scifi: 'ri-rocket-line',
  documentary: 'ri-earth-line',
  animation: 'ri-palette-line',
  variety: 'ri-mic-line',
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类别探索您感兴趣的视频内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.filter(c => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 text-center border border-background-200/70 hover:border-accent-300 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                <i className={`${categoryIcons[cat.slug] || 'ri-folder-line'} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-400">海量高清资源</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}